/**
 * @Author: 左建
 * @Date: 2022/8/18 11:00
 * @LastEditTime: 2022/8/18 11:00
 * @Description: 客观管理静态配置
*/

// 获取搜索表单默认值
export function getIntiSearchForm (params) {
    return {
        SourceType: undefined, // 课程类型
        SourceState: undefined, // 课程状态
        keyWord: undefined // 课程名称
    }
}
// 获取课程分了options
export const PROJECT_TYPE_OPTIONS = Object.freeze({
    1: "教案",
    2: "学案",
    3: "课件"
})

export const SOURCE_STATE = Object.freeze({
    0: "禁用",
    1: "启用",
})
